let clickCounter = 0;

function loadMoreArticles() {
    const moreArticlesButtons = document.querySelectorAll('.js_loadMoreArticles');
    if (!moreArticlesButtons.length) return;

    moreArticlesButtons.forEach(button => {
        button.addEventListener('click', async function handler(event) {
            event.preventDefault();
            button.removeEventListener('click', handler);

            const icon = button.querySelector('i');
            const url = button.dataset.moreArticles;
            let categorySlug = window.location.pathname;

            clickCounter++;

            window.dm?.AjaxEvent("pageview");

            categorySlug = (categorySlug === '/' || categorySlug === '') ? 'Naslovnica' : categorySlug.split('/')[1];

            const removeBtn = document.querySelector('.js_removeAfterLoad');
            button.classList.add('is_loading');

            try {
                const response = await fetch(url);
                const data = await response.text();

                await new Promise(resolve => setTimeout(resolve, 1500));

                icon?.classList.remove('is_loading');

                const wrapper = document.createElement('div');
                wrapper.innerHTML = data;

                const feedContainer = document.querySelector('.js_loadExtraFeed');
                if (feedContainer) {
                    while (wrapper.firstChild) {
                        feedContainer.appendChild(wrapper.firstChild);
                    }
                    feedContainer.classList.remove('hidden');
                }

                removeBtn?.remove();
                picturePolyfill?.parse();

                loadMoreArticles();

            } catch (err) {
                console.error('Greška pri učitavanju dodatnih članaka:', err);
                button.classList.remove('is_loading');
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", () => loadMoreArticles());
